import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  Icon,
  IconButton,
  Switch,
  FormControlLabel,
} from '@material-ui/core';


const SetupPrices = ({ setupData, editTitle, editOption, addOption, removeOption }) => {
  const {price} = setupData;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        <Typography variant="h4" className="text-brand ml-4 mt-8">Setup Prices</Typography>
      </Grid>
      {price &&
      <Grid item xs={12} sm={6}>
        <TextField
          variant="outlined"
          defaultValue={price.title}
          onBlur={(e) => editTitle('price', e.target.value)}
          fullWidth
          label={
            <div className="flex items-center">
              Title
            </div>
          }
        />
      </Grid>}
      {!price?.options?.length &&
      <IconButton
        onClick={() => addOption('price')}
        title="Add"
      >
        <Icon>add</Icon>
      </IconButton>}
      {price.options && price.options.map((option, idx) => (
        <Grid key={option._id || option.id} item xs={12} sm={12} className="flex">
          <TextField
            variant="outlined"
            defaultValue={option.label}
            name="label"
            onBlur={(e) => editOption(e, 'price', idx)}
            fullWidth
            label={
              <div className="flex items-center">
                Label
              </div>
            }
            helperText={!price.options[idx]?.label?.length && 'Field is required'}
            error={!price.options[idx]?.label?.length}
          />
          <TextField
            className="ml-4"
            variant="outlined"
            type="number"
            name="price"
            defaultValue={option.price}
            onBlur={(e) => editOption(e, 'price', idx)}
            label={
              <div className="flex items-center">
                Price
              </div>
            }
            helperText={!price.options[idx]?.price?.toString().length && 'Field is required'}
            error={!price.options[idx]?.price?.toString().length}
          />
          <FormControlLabel
            control={
              <Switch
                onChange={(e) => editOption(e, 'price', idx)}
                checked={option.isOneTime}
                color="primary"
                name="isOneTime"
                className="ml-2"
              />}
            label="isOneTime"
            labelPlacement="top"
          />
          <IconButton
            onClick={() => removeOption('price', idx)}
            title="Delete"
            className="h-50px"
          >
            <Icon>delete</Icon>
          </IconButton>
          <IconButton
            onClick={() => addOption('price', idx)}
            title="Add"
            className="h-50px"
          >
            <Icon>add</Icon>
          </IconButton>
        </Grid>
      ))}
    </Grid>
  );
};

export default SetupPrices;
